import { render, staticRenderFns } from "./GroupDashboardYearlyPie.vue?vue&type=template&id=17a35772&"
import script from "./GroupDashboardYearlyPie.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardYearlyPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports